import React from "react";
import { Grid } from "@material-ui/core"

import { DocumentItem } from "./fields/DocumentsField/components/DocumentItem"

export const SearchResultDocumentsRowExpand = ({ replaceResource, ...props }) => {	
	const data = props.record["documents"];
	const relatedEntityId = props.record["id"];
	const resource = replaceResource ?? props.resource;

	return (		
		<Grid container spacing={2}>
			{data && data.map(item => 
				<Grid key={item.id} item xs={12} sm={6} md={3}>
					<DocumentItem 
						isReadOnly={true} 
						data={{ ...item, relatedEntityId: relatedEntityId, parsed_status: 1 }} 
						resource={resource} 
					/>
				</Grid>
			)}
		</Grid>
	);
};
